import { InputNumberLocalized } from '@components'

import { FormItem, Text } from '@billy/design-system'
import { ReactElement } from 'react'

interface ImportedInvoiceReviewVatAmountFieldProps {
  currency: string | null
  label: string
  value: number | null
}

/** Calculated from the line's amount and VAT rate, so it is never a form value and can't be edited. */
export const ImportedInvoiceReviewVatAmountField = ({
  currency,
  label,
  value,
}: ImportedInvoiceReviewVatAmountFieldProps): ReactElement => (
  <FormItem label={label}>
    {({ id }) => (
      <InputNumberLocalized
        disabled
        id={id}
        isFallbackToZero={false}
        suffix={currency && <Text colorVariant="secondary">{currency}</Text>}
        value={value ?? undefined}
      />
    )}
  </FormItem>
)
